import LocalAuthentication from '@security/data/usecases/LocalAuthentication';
import LocalStorageAuthStorage from '@security/infra/protocols/storage/LocalStorageAuthStorage';

export default new LocalAuthentication(new LocalStorageAuthStorage());
